import React from 'react';
import {Spin, Table, Typography} from 'antd';
import dayjs from 'dayjs';

import EngageCurrency from './EngageCurrency';
import DepositExchangeDrawer from './DepositExchangeDrawer';
import {dateFormat, timeFormat} from '../../lib/time';
import {emptyDepositsHistoryText} from '../../helpers/text';
import {black, successGreen} from '../../assets/colors';
import {DepositHistoryProps} from '../../types/purchaseTypes';

import './DepositHistory.less';

const columns = [
    {
        title: <Typography.Text strong>Date</Typography.Text>,
        dataIndex: 'purchased_at',
        key: 'purchased_at_date',
        render: (purchased_at: string) => (
            <span className="purchased-date-line-item long-text-wrap">
                {dayjs(purchased_at).tz().format(dateFormat)}
            </span>
        ),
    },
    {
        title: <Typography.Text strong>Time</Typography.Text>,
        dataIndex: 'purchased_at',
        key: 'purchased_at_time',
        render: (purchased_at: string) => (
            <span className="purchased-time-line-item long-text-wrap">
                {dayjs(purchased_at).tz().format(timeFormat)}
            </span>
        ),
    },
    {
        title: <Typography.Text strong>Amount</Typography.Text>,
        dataIndex: 'amount',
        key: 'amount',
        render: (amount: string) => (
            <span className="amount-line-item long-text-wrap">
                <EngageCurrency
                    amount={parseFloat(amount)}
                    style={{color: parseFloat(amount) > 0 ? black : successGreen}}
                />
            </span>
        ),
    },
    {
        title: <Typography.Text strong>Deposit Balance</Typography.Text>,
        dataIndex: 'balance',
        key: 'deposit_balance',
        render: (balance: string) => (
            <span className="deposit-balance-line-item long-text-wrap">
                <EngageCurrency
                    amount={parseFloat(balance)}
                    style={{color: parseFloat(balance) > 0 ? black : successGreen}}
                />
            </span>
        ),
    },
];

const DepositHistory = ({
                            loading,
                            totalRows,
                            purchases,
                            curDepositValue,
                            accountingBalance
                        }: DepositHistoryProps) => {
    // Pagination states.
    const [page, setPage] = React.useState(1);
    const [perPage, setPerPage] = React.useState(10);

    // Pagination logic.
    const onChange = (page: number, perPage: number) => {
        setPage(page);
        setPerPage(perPage);
    };

    const paginationAttr = {
        current: page,
        pageSize: perPage,
        total: totalRows,
        onChange,
        showSizeChanger: true,
        simple: window.innerWidth <= 767,
        showTotal: (total: number, range: [number, number]) => `${range[0]}-${range[1]} of ${total} items`,
        onShowSizeChange: onChange,
    };

    return (
        <Spin spinning={loading}>
            <Table
                rowKey="id"
                dataSource={purchases}
                columns={columns}
                bordered={false}
                className="deposit-history-table responsive-table"
                pagination={paginationAttr}
                title={() =>
                    <div className="deposit-history-table-title">
                        <div>
                            <Typography.Text>Deposit Transaction History</Typography.Text>
                        </div>
                        <div className="deposit-history-table-btn-container">
                            <DepositExchangeDrawer
                                typeOfTransaction="reduce"
                                curDepositValue={curDepositValue}
                                accountingBalance={accountingBalance}
                            />
                            <DepositExchangeDrawer
                                typeOfTransaction="increase"
                                curDepositValue={curDepositValue}
                                accountingBalance={accountingBalance}
                            />
                        </div>
                    </div>
                }
                locale={{emptyText: (<div className="empty-data-table">{emptyDepositsHistoryText}</div>)}}
            />
        </Spin>
    );
};

export default DepositHistory;
